<template>
  <Teleport v-if="shouldRender" :key="renderKey" to="#blokkli-add-list-actions">
    <AddListItem
      :id="type"
      ref="item"
      :label="title"
      :icon="icon"
      :orientation="ui.addListOrientation.value"
      :color="color"
      :disabled="disabled"
      data-element-type="action"
      :data-action-type="type"
      :data-item-bundle="itemBundle"
      no-context-menu
    />
  </Teleport>
</template>

<script setup>
import { computed, useBlokkli, nextTick, ref } from "#imports";
import { AddListItem } from "#blokkli/components";
import onBlokkliEvent from "#blokkli/helpers/composables/onBlokkliEvent";
import defineTourItem from "#blokkli/helpers/composables/defineTourItem";
const props = defineProps({
  type: { type: String, required: true },
  title: { type: String, required: true },
  icon: { type: null, required: true },
  itemBundle: { type: String, required: false },
  color: { type: String, required: true },
  description: { type: String, required: false },
  disabled: { type: Boolean, required: false },
  weight: { type: Number, required: false }
});
const item = ref(null);
const emit = defineEmits(["placed"]);
const { ui, state, features } = useBlokkli();
const addListAvailable = computed(
  () => !!features.mountedFeatures.value.find((v) => v.id === "add-list")
);
const shouldRender = computed(
  () => addListAvailable.value && state.editMode.value === "editing"
);
const renderKey = ref("");
onBlokkliEvent("add-list:change", () => {
  nextTick(() => {
    renderKey.value = Math.round(Math.random() * 1e9).toString();
  });
});
onBlokkliEvent("action:placed", (e) => {
  if (e.action.actionType !== props.type) {
    return;
  }
  emit("placed", e);
});
defineTourItem(() => {
  if (!props.description) {
    return;
  }
  return {
    id: "plugin:add_action:" + props.type,
    title: props.title,
    text: props.description,
    element: () => item.value?.getElement()
  };
});
</script>

<script>
export default {
  name: "PluginAddAction"
};
</script>
